//scrollPosition
var scrollStatus = function(){
    
    var scale = 10;
  
};
